// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Privacy policy
 */

.Privacy_doc__2k1JM {
  max-width: 760px;
  padding-top: var(--space-6);
  color: var(--text-primary);
  font-size: 1rem;
  line-height: 1.65;
}

.Privacy_doc__2k1JM h2 {
  margin: var(--space-6) 0 var(--space-2);
  font-size: 1.2rem;
  font-weight: 700;
  letter-spacing: -0.01em;
}

.Privacy_doc__2k1JM p,
.Privacy_doc__2k1JM ul {
  margin: 0 0 var(--space-3);
  color: var(--text-secondary);
}

.Privacy_doc__2k1JM ul {
  padding-left: 1.25rem;
}

.Privacy_doc__2k1JM li {
  margin-bottom: var(--space-2);
}

.Privacy_doc__2k1JM b {
  color: var(--text-primary);
}

.Privacy_title__BxoKW {
  font-size: clamp(1.6rem, 1.3rem + 1vw, 2.2rem);
  font-weight: 700;
  line-height: 1.15;
  letter-spacing: -0.022em;
  margin: 0;
}

.Privacy_updated__2AYUU {
  margin-top: var(--space-1);
  font-size: 0.875rem;
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/Privacy.module.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,uCAAuC;EACvC,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,8CAA8C;EAC9C,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB","sourcesContent":["/*\n * Privacy policy\n */\n\n.doc {\n  max-width: 760px;\n  padding-top: var(--space-6);\n  color: var(--text-primary);\n  font-size: 1rem;\n  line-height: 1.65;\n}\n\n.doc h2 {\n  margin: var(--space-6) 0 var(--space-2);\n  font-size: 1.2rem;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n}\n\n.doc p,\n.doc ul {\n  margin: 0 0 var(--space-3);\n  color: var(--text-secondary);\n}\n\n.doc ul {\n  padding-left: 1.25rem;\n}\n\n.doc li {\n  margin-bottom: var(--space-2);\n}\n\n.doc b {\n  color: var(--text-primary);\n}\n\n.title {\n  font-size: clamp(1.6rem, 1.3rem + 1vw, 2.2rem);\n  font-weight: 700;\n  line-height: 1.15;\n  letter-spacing: -0.022em;\n  margin: 0;\n}\n\n.updated {\n  margin-top: var(--space-1);\n  font-size: 0.875rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"doc": `Privacy_doc__2k1JM`,
	"title": `Privacy_title__BxoKW`,
	"updated": `Privacy_updated__2AYUU`
};
export default ___CSS_LOADER_EXPORT___;
